import { type UseMutationResult, useMutation } from '@tanstack/react-query';
import { createFloraFeedback } from './flora-feedback-client';
import type { FloraFeedbackError, FloraFeedbackPayload, FloraFeedbackResponse } from './flora-feedback-client.type';

/**
 * Mutation hook for submitting Flora response feedback.
 *
 * Intentionally thin: there is no read endpoint to invalidate. The calling component
 * passes per-call `mutate(payload, { onSuccess, onError })` handlers to drive the toast
 * and "feedback sent" UI state (both a success and a 409 flip that local state).
 *
 * @returns {UseMutationResult<FloraFeedbackResponse, FloraFeedbackError, FloraFeedbackPayload>} The mutation object for creating feedback.
 */
const useCreateFloraFeedbackMutation = (): UseMutationResult<
  FloraFeedbackResponse,
  FloraFeedbackError,
  FloraFeedbackPayload
> =>
  useMutation<FloraFeedbackResponse, FloraFeedbackError, FloraFeedbackPayload>({
    mutationFn: createFloraFeedback,
  });

export { useCreateFloraFeedbackMutation };
